import React from "react";
import { setFocusedStore } from "tsi-common-react/src/apps/retail/reducers";
import {
    filteredStoreSelector,
    focusedStoreIDSelector,
    loadingStoresSelector,
} from "tsi-common-react/src/apps/retail/selectors";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/store/reducers";

import { LocatorNearestStores as LocatorNearestStoresComponent } from "./LocatorNearestStoresContent";

export const LocatorNearestStores = (): React.ReactNode => {
    const stores = useAppSelector(filteredStoreSelector);
    const isLoadingStores = useAppSelector(loadingStoresSelector);
    const focusedStoreID = useAppSelector(focusedStoreIDSelector);
    const filters = useAppSelector((state) => state.retail.storeFilters);
    const dispatch = useAppDispatch();

    return (
        <LocatorNearestStoresComponent
            stores={stores}
            focusedStoreID={focusedStoreID}
            onSelectStore={(externalID) =>
                dispatch(setFocusedStore({ externalID }))
            }
            showMore={filters.limit ? true : false}
            isLoadingStores={isLoadingStores}
        />
    );
};
